import { graphql } from 'react-relay';

export const gqlLastSalesSyncCompletedOverall = graphql`
  query lastSalesSyncCompletedOverallQuery {
    invsysLastSalesSyncCompletedOverall
  }
`;
